import React from 'react';
import { Box, Container, Typography, Link, IconButton } from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';

const Footer = () => {
  return (
    <Box sx={{ backgroundColor: '#2f2f2f', color: 'gold', padding: '20px 0' }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: { xs: 'center', md: 'flex-start' },
            gap: { xs: 4, md: 0 },
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <Box>
            <Typography variant="h6" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body1">
              Email: <Link href="mailto:info@ayurvediceshop.net" color="inherit">info@ayurvediceshop.net</Link>
            </Typography>
            <Typography variant="body1">
              Phone: <Link href="tel:9731842401" color="inherit">9731842401</Link>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Typography variant="body1">
              <Link href="#" color="inherit">About Us</Link>
            </Typography>
            <Typography variant="body1">
              <Link href="#" color="inherit">Contact Us</Link>
            </Typography>
            <Typography variant="body1">
              <Link href="#" color="inherit">Privacy Policy</Link>
            </Typography>
            <Typography variant="body1">
              <Link href="#" color="inherit">Terms of Service</Link>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" gutterBottom>
              Follow Us
            </Typography>
            <Box>
              <IconButton component="a" href="https://x.com/" color="inherit">
                <TwitterIcon />
              </IconButton>
              <IconButton component="a" href="https://www.instagram.com/" color="inherit">
                <InstagramIcon />
              </IconButton>
              <IconButton component="a" href="https://www.linkedin.com/feed/" color="inherit">
                <LinkedInIcon />
              </IconButton>
              <IconButton component="a" href="https://github.com/" color="inherit">
                <GitHubIcon />
              </IconButton>
            </Box>
          </Box>
        </Box>
        <Typography variant="body2" color="inherit" align="center" sx={{ mt: 3 }}>
          © 2024 Ayurvedic e-shop. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
